const LOCALIZATIONS_GET = 'LOCALIZATIONS_GET'
const LOCALIZATIONS_GET_SUCCESS = 'LOCALIZATIONS_GET_SUCCESS'
const LOCALIZATIONS_GET_ERROR = 'LOCALIZATIONS_GET_ERROR'

export { LOCALIZATIONS_GET, LOCALIZATIONS_GET_SUCCESS, LOCALIZATIONS_GET_ERROR }
